import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IQuestion } from '../../../../interfaces/question.interface';

@Component({
  selector: 'app-coordinate-answer',
  templateUrl: './coordinate-answer.component.html',
  styleUrls: ['./coordinate-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CoordinateAnswerComponent {
  isLoading = false;
  @Input() question: IQuestion;
  form: UntypedFormGroup = this.fb.group({
    value: null,
  });
  constructor(
    private fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef
  ) {}

  getCords(): void {
    if (navigator.geolocation) {
      this.isLoading = true;
      navigator.geolocation.getCurrentPosition(
        (data) => {
          this.isLoading = false;
          this.form.patchValue({
            value: [data.coords.latitude, data.coords.longitude],
          });
          this.cdr.markForCheck();
        },
        () => {
          this.isLoading = false;
          this.form.get('value').setErrors({
            positionInvalid: true,
          });
          this.cdr.markForCheck();
        }
      );
    }
  }
}
